// src/components/store/sections/hero-banner/HeroV58PodiumspotlightSlateGold.tsx
"use client";

import React from "react";
import DynamicHeroVariant from "./DynamicHeroVariant";

export default function HeroV58PodiumspotlightSlateGold(props: any) {
  return (
    <DynamicHeroVariant
      variantNumber={58}
      archKey="podium_spotlight"
      archLabel="3D Podium Spotlight"
      palName="SlateGold"
      grad="from-slate-800 via-zinc-900 to-neutral-950"
      lightBg="bg-amber-50/80"
      textCol="text-amber-700"
      borderCol="border-amber-300"
      btnCls="bg-slate-900 hover:bg-slate-800"
      {...props}
    />
  );
}
